import React from "react";
import "./pagination.css";

const Pagination = ({ pagination, postsPerPage, handlePageSizeChange, fetchDetail }) => {
  // Safe numeric coercion to prevent API string serialization bugs (e.g., "100" vs 100)
  const currentPage = Number(pagination?.page || 1);
  const totalPages = Number(pagination?.total_pages || 0);

  // Hide pagination entirely if there is only 1 page or no records
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagination-wrapper">
      {/* Left: Page size dropdown */}
      <div className="entries-per-page-container">
        <select
          name="entries"
          className="entries-per-page-select"
          value={postsPerPage}
          onChange={handlePageSizeChange}
        >
          <option value={5}>5 / page</option>
          <option value={10}>10 / page</option>
          <option value={20}>20 / page</option>
          <option value={50}>50 / page</option>
          <option value={100}>100 / page</option>
        </select>
      </div>

      {/* Right: Numbered Pagination */}
      <nav aria-label="Page navigation" style={{ paddingRight: 10, paddingBottom: 10 }}>
        <ul className="pagination mb-0">
          {/* Previous */}
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => fetchDetail(currentPage - 1, postsPerPage)}
              disabled={currentPage === 1}
            >
              &laquo;
            </button>
          </li>

          {/* Numbered pages with ellipsis */}
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => {
            if (
              num === 1 ||
              num === totalPages ||
              (num >= currentPage - 2 && num <= currentPage + 2)
            ) {
              return (
                <li
                  key={num}
                  className={`page-item ${num === currentPage ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => fetchDetail(num, postsPerPage)}
                  >
                    {num}
                  </button>
                </li>
              );
            } else if (num === currentPage - 3 || num === currentPage + 3) {
              return (
                <li key={num} className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              );
            } else {
              return null;
            }
          })}

          {/* Next */}
          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => fetchDetail(currentPage + 1, postsPerPage)}
              disabled={currentPage === totalPages}
            >
              &raquo;
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;